module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Price2-34ced6dff82843aedabac5c3d8537b54.svg";